import * as React from "react";

import {consumeContext}             from "@Common/react/context";
import {ComponentLink, makeChain}   from "@Common/react/cst2";
import {UseState}                   from "@Common/react/use-state";
import {back}                       from "@Common/utils/browser/back";

import {PendingOrdersTable}         from "../account/orders/pending-route/orders-table/orders-table";
import {PendingOrdersTableState}    from "../account/orders/pending-route/orders-table/orders-table-state";
import {SubHeader}                  from "../common/sub-header/sub-header";
import {Layout}                     from "../layout/layout";

export const OrdersRoute = () => (
    makeChain<JSX.Element>()
    .then(...consumeContext("routerHistory"))
    .then("sortState", ({}, next:ComponentLink<typeof UseState<{id: string, ascending: boolean}>>) => UseState({next, initValue: {id: "date", ascending: false}}))
    .then("tableState", ({sortState}, next:ComponentLink<typeof PendingOrdersTableState>) => PendingOrdersTableState({next, searchQuery: "", sortMode: sortState.value}))
    .then(({sortState, tableState, routerHistory}) => (
        <Layout>
            <SubHeader
                backLink={
                    <a
                        onClick={() => back({fallbackAction: async () => routerHistory.push("/")})}
                        className="back"
                        xd-qa-type="link"
                        xd-qa-name="Back"
                    >
                        <i className="fa fa-chevron-left"/> Back
                    </a>
                }
                title={"Orders"}
            />

            <PendingOrdersTable {...tableState} sortState={sortState}/>
        </Layout>
    ))
    .run()
);

